import { createAppAsyncThunk } from '@/admin/helpers';
import { t } from '@/core/localization';
import { showApiSuccessSnackbar } from '@/shared/helpers/thunk';
import { stockReceiptApi } from '../stockReceipt.api';
import { stockReceiptActions } from '../stockReceipt.state';
const exportSurplusItemsToExcel = createAppAsyncThunk('stockReceipt/exportSurplusItemsToExcel', async ({ onlyNotFound }, { getState, dispatch, rejectWithValue }) => {
    const { surplusItemsPrices } = getState().stockReceipt.uploadSurplusItemsDialog;
    if (!surplusItemsPrices)
        return;
    dispatch(stockReceiptActions.setIsSurplusItemsRequestFetching(true));
    const requestPayload = {
        searchId: surplusItemsPrices.searchId,
        onlyNotFound,
    };
    try {
        await dispatch(stockReceiptApi.endpoints.exportSurplusItemsToExcel.initiate(requestPayload)).unwrap();
        dispatch(showApiSuccessSnackbar(t('file.successfully.downloaded')));
    }
    catch {
        return rejectWithValue('fail');
    }
    finally {
        dispatch(stockReceiptActions.setIsSurplusItemsRequestFetching(false));
    }
});
export { exportSurplusItemsToExcel };
